export default __webpack_public_path__ + "static/media/scheduleimg.df3be1a6.svg";